module.exports = {"350181002":"玉屏街道","350181003":"龙山街道","350181004":"龙江街道","350181005":"宏路街道","350181006":"石竹街道","350181007":"音西街道","350181008":"阳下街道","350181103":"海口镇","350181104":"城头镇","350181105":"南岭镇","350181106":"龙田镇","350181107":"江镜镇","350181108":"港头镇","350181109":"高山镇","350181110":"沙埔镇","350181111":"三山镇","350181112":"东瀚镇","350181113":"渔溪镇","350181114":"上迳镇","350181115":"新厝镇","350181116":"江阴镇","350181117":"东张镇","350181118":"镜洋镇","350181119":"一都镇","350181400":"江镜华侨","350181401":"东阁华侨"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350181.json
// module id = 1077
// module chunks = 0